const Spinner = () => {
	return (
		<>
			<span className="sci-bcl-loader"></span>
			<div className="sci-bcl-loader__overlay"></div>
		</>
	);
};

export default Spinner;
